import styled from '@emotion/styled';

interface IProps {
	hasValue: boolean;
}

export const DropdownContainer = styled.div`
	position: relative;
	min-width: 10rem;
	height: ${(props) => props.theme.ui.form.controlHeight};
	width: 100%;
`;

export const SelectBox = styled.div<{ isOpen: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.8rem;
	height: 100%;
	padding: 0 1.6rem;
	border: 1px solid ${(props) => (props.isOpen ? props.theme.ui.interactive.primary : props.theme.ui.border.strong)};
	border-radius: ${(props) => props.theme.ui.form.controlRadius};
	background-color: ${(props) => props.theme.ui.surface.page};
	cursor: pointer;
	transition:
		border-color ${(props) => props.theme.effects.transitionFast},
		box-shadow ${(props) => props.theme.effects.transitionFast};

	&:hover {
		border-color: ${(props) => props.theme.colors.primary200};
	}
`;

export const SelectedText = styled.span<IProps>`
	color: ${(props) => (props.hasValue ? props.theme.ui.text.primary : props.theme.ui.text.muted)};
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	white-space: nowrap;
`;

export const ArrowIcon = styled.span<{ isOpen: boolean }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: ${(props) => props.theme.ui.text.muted};
	transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
	transition: transform ${(props) => props.theme.effects.transitionFast};
	font-size: 1.2rem;
`;

export const OptionsList = styled.ul<{ isOpen: boolean }>`
	position: absolute;
	top: calc(100% + 0.4rem);
	left: 0;
	right: 0;
	margin: 0;
	padding: 0.6rem;
	list-style: none;
	border: 1px solid ${(props) => props.theme.ui.border.default};
	border-radius: ${(props) => props.theme.ui.form.controlRadius};
	background-color: ${(props) => props.theme.ui.surface.page};
	box-shadow: ${(props) => props.theme.effects.shadowMd};
	z-index: 10;
	max-height: ${(props) => (props.isOpen ? '20rem' : '0')};
	opacity: ${(props) => (props.isOpen ? '1' : '0')};
	visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
	transition:
		opacity ${(props) => props.theme.effects.transitionFast},
		visibility ${(props) => props.theme.effects.transitionFast};
	overflow-y: auto;
`;

export const OptionItem = styled.li`
	padding: 1rem 1.2rem;
	border-radius: ${(props) => props.theme.effects.radiusSm};
	cursor: pointer;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	color: ${(props) => props.theme.ui.text.primary};

	&:hover {
		background-color: ${(props) => props.theme.ui.interactive.primaryMuted};
		color: ${(props) => props.theme.ui.text.accent};
	}
`;
